<template>
  <div data-app>
    <v-card>
      <v-card-title>
        Websites
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="collection"
        :search="search"
        :sort-by="['name']"
        @click:row="handleClickItem"
      >
        <template v-slot:top>
          <v-toolbar flat>
            <!-- <v-toolbar-title>My CRUD</v-toolbar-title> -->
            <!-- <v-divider class="mx-4" inset vertical></v-divider> -->
            <!-- <v-spacer></v-spacer> -->
            <WebSiteModalForm
              :loader="loader"
              :modalData="modalData"
              :statuses="statuses"
              :permissions="permissions"
              @closeModalForm="handleCloseModalForm"
              @saveModalForm="handleSaveModalForm"
            ></WebSiteModalForm>
            <v-spacer></v-spacer>
            <v-checkbox v-model="showAll" label="Active sites"></v-checkbox>

            <v-dialog v-model="dialogDelete" max-width="500px">
              <v-card>
                <v-card-title class="headline"
                  >Are you sure you want to delete this item?</v-card-title
                >
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="closeDelete"
                    >Cancel</v-btn
                  >
                  <v-btn
                    color="blue darken-1"
                    text
                    @click="deleteItemConfirm"
                    v-if="permissionCan('delete')"
                    >OK</v-btn
                  >
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>

        <template v-slot:item.status="{ item }">
          <span v-if="statuses.system">{{
            statuses.companySettings.site[item.status].value
          }}</span>
        </template>
        <template v-slot:item.actions="{ item }">
          <!-- <router-link
            :to="`/companysettings/sites/${item.id}`"
            v-if="permissionCan('view')"
          >
            <v-icon small class="mr-2"> mdi-pencil </v-icon>
          </router-link> -->
          <v-icon
            small
            @click="deleteItem(item)"
            v-if="permissionCan('delete')"
          >
            mdi-delete
          </v-icon>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ApiService from "@/core/services/api.service";
// import i18nService from "@/core/services/i18n.service.js";
import WebSiteModalForm, { initialFormData } from "./WebSiteModalForm";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

export default {
  name: "WebSite",
  components: { WebSiteModalForm },
  data() {
    return {
      loader: false,
      showAll: false,
      search: "",
      collection: [],
      permissions: [],
      headers: [
        {
          text: "Domain",
          value: "name",
        },
        { text: "URL", value: "url" },
        { text: "Pricelist", value: "priceList" },
        { text: "IP", value: "ip_address" },
        { text: "Actions", value: "actions", sortable: false },
      ],

      modalData: {
        dialog: false,
        editedIndex: -1,
        editedItem: initialFormData,
        defaultItem: initialFormData,
      },

      dialogDelete: false,
    };
  },

  computed: {
    ...mapGetters(["webSiteCollection", "statuses"]),
  },

  watch: {
    dialogDelete(val) {
      val || this.closeDelete();
    },
    showAll() {
      if (this.webSiteCollection.length > 0) {
        this.filterCollection(this.webSiteCollection);
      }
    },
    "$route.params.id": {
      handler: function (id) {
        if (id) {
          this.editItem(id);
        }
      },
      deep: true,
      immediate: true,
    },
    webSiteCollection(val) {
      this.filterCollection(val);
    },
  },

  methods: {
    ...mapActions(["fetchWebSite"]),
    editItem(id) {
      this.loader = true;
      ApiService.get("companySetting/website/" + id)
        .then(({ data }) => {
          this.modalData.editedIndex = 1;
          if (!data.contact_data) {
            data.contact_data = [{}];
          }
          this.modalData.editedItem = Object.assign({}, data);
          this.modalData.dialog = true;
        })
        .catch((error) => {
          console.log("Error!: ", error);
        })
        .finally(() => {
          this.loader = false;
        });
    },

    deleteItem(item) {
      this.editedIndex = this.webSiteCollection.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      ApiService.delete("companySetting/website/" + this.editedItem.id)
        .then(() => {
          this.fetchWebSite();
        })
        .catch((error) => {
          console.log("Error!: ", error);
        });
      this.closeDelete();
    },

    handleCloseModalForm() {
      this.modalData.dialog = false;
      this.modalData.editedIndex = -1;
      this.modalData.editedItem = this.modalData.defaultItem;
      if (this.$route.name !== "websites")
        this.$router.push({ name: "websites" });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    handleSaveModalForm(model) {
      /**Delete unused translations */
      // i18nService.languages.forEach((item) => {
      //   let langCode = item.lang;
      //   if (
      //     model.translations[langCode] &&
      //     model.translations[langCode].name == ""
      //   ) {
      //     delete model.translations[langCode];
      //   }
      // });
      model.country = { id: model.country };
      this.loader = true;
      if (this.modalData.editedIndex > -1) {
        ApiService.put("companySetting/website/" + model.id, model)
          .then(() => {
            this.fetchWebSite();
            this.handleCloseModalForm();
          })
          .catch((error) => {
            console.log("Error!: ", error);
          })
          .finally(() => {
            this.loader = false;
          });
      } else {
        //create model
        ApiService.post("companySetting/website", model)
          .then(({ data }) => {
            console.log(data);
            this.fetchWebSite();
            this.handleCloseModalForm();
          })
          .catch((error) => {
            console.log("Error!: ", error);
          })
          .finally(() => {
            this.loader = false;
          });
      }
    },

    filterCollection(coll) {
      if (!this.showAll) {
        this.collection = coll;
      } else {
        this.collection = coll.filter((item) => {
          return item.status == 1;
        });
      }
    },

    handleClickItem(item) {
      if (this.permissionCan("view") && !this.dialogDelete) {
        this.$router.push(`/companysettings/websites/${item.id}`);
      }
    },

    permissionCan(action) {
      return this.permissions.find(
        (x) => x.name == "companySettings.site." + action
      );
    },
    setPermissions() {
      if (localStorage.permissions) {
        this.permissions = JSON.parse(localStorage.permissions).filter(
          (item) => item.name.indexOf("site") > -1
        );
      }
    },
  },

  async mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Website" }]);
    this.fetchWebSite();
    this.setPermissions();
  },
};
</script>
